import React, { useState } from 'react'
import paths from 'routes/paths';
import Button from 'components/_UI/Button'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import Text from 'components/_UI/Text';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import WithdrawModal from '../withdraw/WithdrawModal';
import { useUser } from 'context/user/User';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import { useNavigate } from 'react-router-dom';
import { DollarSign, FileText } from 'lucide-react';
import Icon from 'components/_UI/Icon';
import routeParams from 'theme/routeParams';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';

export default function RightSlotFinancial() {
    const navigate = useNavigate()
    const { toast, toasts } = useToast()
    const [withdrawModal, setWithdrawModal] = useState(false);
    const { user } = useUser()

    function navigateTo(param) {
        navigate(`${paths.dashboard.financial}?${param}=1`)
    }

    return (
        <RightSlotContainer>
            <ToastContainer toasts={toasts} />

            <ActionButton onClick={() => navigateTo(routeParams.financial.invoices)}>
                <FileText size={16} color={colors.night} />
                <span>Notas fiscais</span>
            </ActionButton>

            <ActionButton onClick={() => navigateTo(routeParams.financial.bank)}>
                <ContentIconBank>
                    <Icon name='bank' color={colors.night} />
                </ContentIconBank>
                <span>Dados bancários</span>
            </ActionButton>

            <PrimaryAction
                disabled={!user?.has_bank_account}
                onClick={() => user?.has_bank_account && setWithdrawModal(true)}
            >
                <DollarSign size={16} />
                <span>Efetuar saque</span>
            </PrimaryAction>

            <WithdrawModal
                visible={withdrawModal}
                onClose={() => setWithdrawModal(false)}
                onSucess={() => toast.success('Saque efetuado com sucesso.', { position: 'top-center' })}
            />
        </RightSlotContainer>
    )
}

const RightSlotContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        width: auto;
    }
`;

const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 36px;
    padding: 0 14px;
    border: 1px solid ${colors.night}22;
    border-radius: 8px;
    background: ${colors.neutralLight};
    color: ${colors.nightDark};
    font-size: 13px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.15s ease;

    &:hover {
        background: ${colors.neutral};
        border-color: ${colors.night}44;
    }

    &:focus-visible {
        outline: 2px solid ${panelAccent(colors.occasionalPurple)};
        outline-offset: 2px;
    }
`;

const PrimaryAction = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 36px;
    padding: 0 18px;
    border: none;
    border-radius: 8px;
    background: ${({ disabled }) => disabled ? colors.night + '14' : panelAccent(colors.occasionalPurple)};
    color: ${({ disabled }) => disabled ? colors.night + '66' : colors.neutralLight};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    white-space: nowrap;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background: ${panelAccent(colors.secondaryPurple)};
        box-shadow: 0 2px 8px ${panelAccentAlpha(colors.occasionalPurple, '33')};
    }

    &:focus-visible {
        outline: 2px solid ${panelAccent(colors.occasionalPurple)};
        outline-offset: 2px;
    }
`;

const ContentIconBank = styled.div`
    width: 16px;
    height: 16px;
`;
